export enum ActionTypesReasonCodes {
  SET_REASON_CODES_DATA = 'SET_REASON_CODES_DATA',
  RESET_REASON_CODES = 'RESET_REASON_CODES',
  SET_LOADING_INDICATOR = 'SET_LOADING_INDICATOR',
  SHOW_REASON_CODES_GRID = 'SHOW_REASON_CODES_GRID',
  SET_DISABLED_COLUMNS = 'SET_DISABLED_COLUMNS',
}
export const REASON_CODES_SEARCH_INPUT_PLACEHOLDER = 'Search by Reason Code';
export const REASON_CODES_GRID_TITLE = 'Reason Codes';
export const REASON_CODES_GRID_RECORD_MESSAGE = 'No records to display at this time.';
export const REASON_CODES_GRID_COLUMNS = new Set([
  {
    dataName: 'reasonCode',
    text: 'Reason Code',
    sortable: true,
    isSorted: 0,
    width: '150px',
  },
  {
    // dataName: 'description',
    dataName: 'shortDescription',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    width: '500px',
  },
  {
    dataName: 'partnerServiceId',
    text: 'Partner Service ID',
    sortable: true,
    isSorted: 0,
    width: '180px',
  },
  {
    dataName: 'payDeny',
    text: 'Pay/Deny',
    sortable: true,
    isSorted: 0,
    width: '130px',
  },
  {
    dataName: 'statusChip',
    text: 'Status',
    sortable: true,
    cellType: 'chip',
    isSorted: 0,
  },
]);

export const REASON_CODES_DEFAULT_COLUMNS = new Set([
  'reasonCode',
  // 'description',
  'shortDescription',
  'partnerServiceId',
  'payDeny',
  'statusChip',
]);

export const CREATE_PARTNER_SERVICE_ID_DROPDOWN = [
  { label: '38 - CE', value: 38 },
  { label: '40 - ECE', value: 40 },
  { label: '42 - IRR', value: 42 },
];

export const UPDATE_PARTNER_SERVICE_ID_DROPDOWN = [
  { label: '38 - CE', value: 38 },
  { label: '40 - ECE', value: 40 },
  { label: '42 - IRR', value: 42 },
  { label: '0 - N/A', value: 0 },
];

export const RECOMMENDATION_ACTION_ID_DROPDOWN = [
  { label: 'None', value: 0 },
  { label: 'Pay', value: 1 },
  { label: 'Deny', value: 2 },
];

export const STATUS_DROPDOWN = [
  { label: 'Inactive', value: 0 },
  { label: 'Active', value: 1 },
];
